import React, { useState } from 'react';

import Layout from '../../../containers/Layout';
import BillPayment from '../../../components/AddOrEditPage/AddOrEditLoan/Sections/BillPayment';

export default function BillPaymentDetailsPage() {
  const [title, setTitle] = useState('Bill Payment');

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    {title}
                  </h1>
                </div>
              </div>
              <BillPayment standalone setTitle={setTitle} />
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
